module.exports = __webpack_public_path__ + "img/Foto_Press_Release_RemitPro_x_Volopay_1.587c5da2.jpeg";